export default __webpack_public_path__ + "static/media/imli-adral-lemonade@3x.5cad4a7e.png";